import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Classes} from '../../constants';
import {Question} from '../../models/underwriter.model';

@Component({
    selector: 'app-question-interstitial',
    templateUrl: './question-interstitial.component.html',
    styleUrls: ['./question-interstitial.component.scss'],
    standalone: false
})
export class QuestionInterstitialComponent implements OnInit {

  @Input() question: Question;
  @Input() stepperContent = 'Let\'s start your quote by adding <strong>Vehicles...</strong>'; // Lets start by adding soeme <strong>Vehicles</strong>
  @Input() stepperContentType = 'Vehicles'; // Buildings OR Vehicles OR House Contents OR Personal Items
  @Input() stepperIconImage = '';// 'assets/icn/70px-vehicle.svg';
  @Output() skipStep = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(){
    this.setStepperContent();
  }

  onSkipStepClick(): any {
    this.skipStep.emit(true);
  }

  setStepperContent(){
    this.stepperIconImage = `assets/icn/70px-${Classes[this.question.product_class_id]}.svg`
  }

}
